// extracted by mini-css-extract-plugin
export default {"content":"InfoAddressOrder_content__Uv9ii","address_order_details":"InfoAddressOrder_address_order_details__nF7Pp","address_order_info":"InfoAddressOrder_address_order_info__21B-l"};